import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiLockKey } from 'react-icons/pi';

interface IPasswordProtectButtonProps {
  visible: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const PasswordProtectButton = ({
  visible,
  isLoading,
  disabled,
  onClick,
}: IPasswordProtectButtonProps) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <Button
      type='button'
      isClear
      onlyIcon
      isLoading={isLoading}
      disabled={disabled || isLoading}
      onClick={event => {
        event.stopPropagation();
        onClick();
      }}>
      <Button.Description description={t('button.password-protect')} />
      <Button.Icon icon={<PiLockKey />} />
    </Button>
  );
};

export default PasswordProtectButton;
